import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environment/environment';
import { PlaybookBulkDeleteRemovalStrategy, PlaybookDto } from '../models/playbooks.model';

@Injectable({
  providedIn: 'root',
})
export class PlaybooksApiService extends ApiService {
  getPlaybooks$(): Observable<PlaybookDto[]> {
    return this.get('/Playbooks');
  }

  //todo: switch when api ready
  updatePlaybook$(playbook: PlaybookDto): Observable<PlaybookDto> {
    return this.post('/Playbooks/' + playbook.uniqueId, playbook);
  }

  //todo: switch when api ready
  createPlaybook$(playbook: PlaybookDto): Observable<PlaybookDto> {
    return this.put('/Playbooks', playbook);
  }

  linkClausesToPlaybook$(playbookId: string, clauseIds: string[]): Observable<PlaybookDto> {
    return this.post(`/Playbooks/${playbookId}/link`, { clauseIds });
  }

  unlinkClausesFromPlaybook$(playbookId: string, clauseIds: string[]): Observable<PlaybookDto> {
    return this.post(`/Playbooks/${playbookId}/unlink`, { clauseIds });
  }

  getPlaybook$(id: string): Observable<PlaybookDto> {
    return this.get(`/Playbooks/${id}`);
  }

  bulkDeletePlaybooks$(
    playbookIds: string[],
    removalStrategy: PlaybookBulkDeleteRemovalStrategy,
    targetPlaybookId?: string,
  ): Observable<any> {
    let params = new HttpParams().set('removalStrategy', removalStrategy.toString());

    playbookIds.forEach((playbookId) => {
      params = params.append('playbookIds', playbookId);
    });

    if (targetPlaybookId) {
      params = params.set('targetPlaybookId', targetPlaybookId);
    }

    return this.delete('/Playbooks/bulk-delete', params);
  }
}

export const apiPlaybooksProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiPlaybooks.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiPlaybooks.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiPlaybooks.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiPlaybooks.scopes.write],
  },
];
